var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "kpi-a" }, [
    !_vm.dataloaded
      ? _c("div", { staticClass: "loader" })
      : _c("div", { attrs: { id: "type-c-Chart" } }, [
          _c("div", { staticClass: "flex-col flex-1" }, [
            _c("div", { staticClass: "flex-row flex-1" }, [
              _c("div", { staticClass: "flex-col flex-10" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex-row flex-1 flex-justify-center mb-1 chart-title",
                  },
                  [_vm._v(_vm._s(_vm.kpiAData.technical.kpiName))]
                ),
                _c("div", { staticClass: "flex-row flex-10 mr-1" }, [
                  _c("table", [
                    _c("thead", [
                      _c("tr", [
                        _c("td", { attrs: { rowspan: "2" } }, [_vm._v("KPI")]),
                        _c("td", { attrs: { colspan: "3" } }, [
                          _c("p", [
                            _vm._v("MTC " + _vm._s(_vm.yearLabel) + " ACT"),
                            _c("sup", [_vm._v("1")]),
                          ]),
                        ]),
                        _c("td", { attrs: { colspan: "3" } }, [
                          _vm._v("MTC " + _vm._s(_vm.yearLabel) + " MTP"),
                        ]),
                        _c("td", { attrs: { rowspan: "2" } }, [
                          _vm._v("MTP " + _vm._s(_vm.yearLabel) + " AVG"),
                        ]),
                      ]),
                      _vm._m(0),
                    ]),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.technicalKpiData, function (kpi, i) {
                          return _c("tr", { key: kpi.name }, [
                            _c(
                              "td",
                              {
                                staticClass: "label",
                                staticStyle: { "white-space": "nowrap" },
                              },
                              [
                                _c("p", [
                                  _vm._v(_vm._s(kpi.name)),
                                  _c("sup", [_vm._v(_vm._s(i + 2))]),
                                ]),
                              ]
                            ),
                            _c("td", [_vm._v(_vm._s(kpi.actValue) + "%")]),
                            _c("td", {
                              staticClass: "qrtr",
                              domProps: {
                                innerHTML: _vm._s(_vm.benchMark[kpi.actBM]),
                              },
                            }),
                            _c("td", [
                              kpi.actFleet === 0
                                ? _c("p", [_vm._v("-")])
                                : kpi.actFleet > 0
                                ? _c(
                                    "span",
                                    { staticClass: "caret-up" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "caret-up"] },
                                      }),
                                    ],
                                    1
                                  )
                                : kpi.actFleet < 0
                                ? _c(
                                    "span",
                                    { staticClass: "caret-down" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "caret-down"] },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _c("td", [_vm._v(_vm._s(kpi.mtpValue) + "%")]),
                            _c("td", {
                              staticClass: "qrtr",
                              domProps: {
                                innerHTML: _vm._s(_vm.benchMark[kpi.mtpBM]),
                              },
                            }),
                            _c("td", [
                              kpi.mtpFleet === 0
                                ? _c("p", [_vm._v("-")])
                                : kpi.mtpFleet > 0
                                ? _c(
                                    "span",
                                    { staticClass: "caret-up" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "caret-up"] },
                                      }),
                                    ],
                                    1
                                  )
                                : kpi.mtpFleet < 0
                                ? _c(
                                    "span",
                                    { staticClass: "caret-down" },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "caret-down"] },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _c("td", [_vm._v(_vm._s(kpi.mtpAVG) + "%")]),
                          ])
                        }),
                        _c("tr", [
                          _c("td"),
                          _c("td", { staticClass: "qrtr" }, [_vm._v("◔")]),
                          _c("td", { staticClass: "qrtr" }, [_vm._v("◑")]),
                          _c("td", { staticClass: "qrtr" }, [_vm._v("◕")]),
                          _c("td", { staticClass: "qrtr" }, [_vm._v("⬤")]),
                          _c(
                            "td",
                            { staticClass: "caret-up" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "caret-up"] },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "td",
                            { staticClass: "caret-down" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "caret-down"] },
                              }),
                            ],
                            1
                          ),
                          _c("td"),
                        ]),
                        _vm._m(1),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "flex-col flex-10" }, [
                _c("div", { staticClass: "flex-row flex-4 reverse" }, [
                  _c("div", { staticClass: "flex-col" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-row flex-1 flex-justify-center mb-1 chart-title chart-title-cost",
                      },
                      [_vm._v(" " + _vm._s(_vm.kpiAData.cost.kpiName) + " ")]
                    ),
                    _c("div", { staticClass: "flex-row flex-3 reverse" }, [
                      _c("div", { attrs: { id: _vm.kpi3 } }),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "flex-row flex-1" }, [
                  _c("div", { staticClass: "flex-col flex-1 flex-align-end" }, [
                    _c("div", { staticClass: "flex-row flex-1 text-no-wrap" }, [
                      _c(
                        "span",
                        { staticClass: "legend-red" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "square"] },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" Fleet "),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1 flex-align-end" }, [
                    _c("div", { staticClass: "flex-row flex-1 text-no-wrap" }, [
                      _c(
                        "span",
                        { staticClass: "legend-blue rotate-45-degree" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "square"] },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" " + _vm._s(_vm.yearLabel) + "ACT "),
                    ]),
                  ]),
                  _c("div", { staticClass: "flex-col flex-1 flex-align-end" }, [
                    _c("div", { staticClass: "flex-row flex-1 text-no-wrap" }, [
                      _c(
                        "span",
                        { staticClass: "legend-green" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "circle"] },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" " + _vm._s(_vm.yearLabel) + "MTP "),
                    ]),
                  ]),
                ]),
                _vm._m(2),
              ]),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("tr", [
      _c("td", [_vm._v("Value")]),
      _c("td", [_vm._v("Vs. ex.BM")]),
      _c("td", [_vm._v("Vs. Fleet")]),
      _c("td", [_vm._v("Value")]),
      _c("td", [_vm._v("Vs. ex.BM")]),
      _c("td", [_vm._v("Vs. Fleet")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("tr", [
      _c("td"),
      _c("td", [_vm._v("1st Q")]),
      _c("td", [_vm._v("2nd Q")]),
      _c("td", [_vm._v("3rd Q")]),
      _c("td", [_vm._v("4th Q")]),
      _c("td", [_vm._v("Higher than AVG")]),
      _c("td", [_vm._v("Lower than AVG")]),
      _c("td"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex-row flex-1 flex-justify-end" }, [
      _c("div", { staticClass: "flex-col flex-1 flex-align-end" }, [
        _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
          _c("div", { staticClass: "qrtr1 rotate-90-degree mr-1" }, [
            _vm._v("|"),
          ]),
          _vm._v(" 1st Q "),
        ]),
      ]),
      _c("div", { staticClass: "flex-col flex-1 flex-align-end" }, [
        _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
          _c("div", { staticClass: "qrtr2 rotate-90-degree mr-1" }, [
            _vm._v("|"),
          ]),
          _vm._v("2nd Q"),
        ]),
      ]),
      _c("div", { staticClass: "flex-col flex-1 flex-align-end" }, [
        _c("div", { staticClass: "flex-row flex-1 flex-align-center" }, [
          _c("div", { staticClass: "qrtr3 rotate-90-degree mr-1" }, [
            _vm._v("|"),
          ]),
          _vm._v("3rd Q"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }